/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.app.rpc.SettingsRpc
 */
import * as References from './SettingsRpc';
import { createRpcClientV2, type RpcClientV2 } from 'rpc-client-utils';
import portalsHttpClient from 'portals-platform-lib/portalsHttpClient';
import {
  DataFetchingClientFetcherContext,
  RegisteredQuery,
} from 'data-fetching-client';
import { registerQuery, registerMutation } from 'data-fetching-client/next';
export type AdditionalContextArgs = {
  /**
   * Timeout for the request in milliseconds. If not provided, the default timeout of 5000 will be used.
   */
  timeout?: number;
  /**
   * Not recommended for usage. Please use build time client instead by updating `.client-types.config.ts`file.
   * Docs: https://product.hubteam.com/docs/chirp/pages/tutorials/chirp/FE/custom-clients.html.
   *
   * Used to overwrite the default Chirp Client during runtime.
   */
  customClient?: RpcClientV2;
};

const chirpClient = createRpcClientV2({
  hubHttpClient: portalsHttpClient,
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.app.rpc.SettingsRpc#getUserSettings
 */
export const GET_USER_SETTINGS_QUERY_FIELD_NAME =
  'com_hubspot_portals_platform_app_rpc_SettingsRpc_getUserSettings';
export const GET_USER_SETTINGS_QUERY: RegisteredQuery<
  'result',
  References.GetUserSettingsRequestType,
  References.GetUserSettingsResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_USER_SETTINGS_QUERY_FIELD_NAME,
  args: [
    'membershipToken',
    'utkCookie',
    'portalInstanceId',
    'accountId',
    'objectId',
    'membershipCsrfTokenFromClient',
    'membershipCsrfTokenFromCookie',
    'previewJwt',
    'companyId',
    'tolerateInstanceAccessDenied',
  ],
  fetcher(
    request: References.GetUserSettingsRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetUserSettingsResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getUserSettingsRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.app.rpc.SettingsRpc#updateUserSettings
 */
export const UPDATE_USER_SETTINGS_MUTATION_FIELD_NAME =
  'com_hubspot_portals_platform_app_rpc_SettingsRpc_updateUserSettings';
export const UPDATE_USER_SETTINGS_MUTATION: RegisteredQuery<
  'result',
  References.UpdateUserSettingsRequestType,
  References.UpdateUserSettingsResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: UPDATE_USER_SETTINGS_MUTATION_FIELD_NAME,
  args: [
    'preferredLanguage',
    'firstName',
    'lastName',
    'jobTitle',
    'phone',
    'company',
    'address',
    'city',
    'state',
    'zip',
    'country',
    'membershipToken',
    'utkCookie',
    'portalInstanceId',
    'accountId',
    'objectId',
    'membershipCsrfTokenFromClient',
    'membershipCsrfTokenFromCookie',
    'previewJwt',
    'companyId',
    'tolerateInstanceAccessDenied',
  ],
  fetcher(
    request: References.UpdateUserSettingsRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.UpdateUserSettingsResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.updateUserSettingsRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.app.rpc.SettingsRpc#uploadProfilePhoto
 */
export const UPLOAD_PROFILE_PHOTO_MUTATION_FIELD_NAME =
  'com_hubspot_portals_platform_app_rpc_SettingsRpc_uploadProfilePhoto';
export const UPLOAD_PROFILE_PHOTO_MUTATION: RegisteredQuery<
  'result',
  References.UploadProfilePhotoRequestType,
  References.UploadProfilePhotoResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: UPLOAD_PROFILE_PHOTO_MUTATION_FIELD_NAME,
  args: [
    'imageData',
    'contentType',
    'membershipToken',
    'utkCookie',
    'portalInstanceId',
    'accountId',
    'objectId',
    'membershipCsrfTokenFromClient',
    'membershipCsrfTokenFromCookie',
    'previewJwt',
    'companyId',
    'tolerateInstanceAccessDenied',
  ],
  fetcher(
    request: References.UploadProfilePhotoRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.UploadProfilePhotoResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.uploadProfilePhotoRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.app.rpc.SettingsRpc#changePassword
 */
export const CHANGE_PASSWORD_MUTATION_FIELD_NAME =
  'com_hubspot_portals_platform_app_rpc_SettingsRpc_changePassword';
export const CHANGE_PASSWORD_MUTATION: RegisteredQuery<
  'result',
  References.ChangePasswordRequestType,
  References.ChangePasswordResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: CHANGE_PASSWORD_MUTATION_FIELD_NAME,
  args: [
    'currentPassword',
    'newPassword',
    'newPasswordConfirm',
    'membershipToken',
    'utkCookie',
    'portalInstanceId',
    'accountId',
    'objectId',
    'membershipCsrfTokenFromClient',
    'membershipCsrfTokenFromCookie',
    'previewJwt',
    'companyId',
    'tolerateInstanceAccessDenied',
  ],
  fetcher(
    request: References.ChangePasswordRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.ChangePasswordResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.changePasswordRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.app.rpc.SettingsRpc#getPasswordStatus
 */
export const GET_PASSWORD_STATUS_QUERY_FIELD_NAME =
  'com_hubspot_portals_platform_app_rpc_SettingsRpc_getPasswordStatus';
export const GET_PASSWORD_STATUS_QUERY: RegisteredQuery<
  'result',
  References.GetPasswordStatusRequestType,
  References.GetPasswordStatusResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_PASSWORD_STATUS_QUERY_FIELD_NAME,
  args: [
    'membershipToken',
    'utkCookie',
    'portalInstanceId',
    'accountId',
    'objectId',
    'membershipCsrfTokenFromClient',
    'membershipCsrfTokenFromCookie',
    'previewJwt',
    'companyId',
    'tolerateInstanceAccessDenied',
  ],
  fetcher(
    request: References.GetPasswordStatusRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetPasswordStatusResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getPasswordStatusRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.app.rpc.SettingsRpc#createOrUpdatePassword
 */
export const CREATE_OR_UPDATE_PASSWORD_MUTATION_FIELD_NAME =
  'com_hubspot_portals_platform_app_rpc_SettingsRpc_createOrUpdatePassword';
export const CREATE_OR_UPDATE_PASSWORD_MUTATION: RegisteredQuery<
  'result',
  References.CreateOrUpdatePasswordRequestType,
  References.CreateOrUpdatePasswordResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: CREATE_OR_UPDATE_PASSWORD_MUTATION_FIELD_NAME,
  args: [
    'currentPassword',
    'newPassword',
    'newPasswordConfirm',
    'membershipToken',
    'utkCookie',
    'portalInstanceId',
    'accountId',
    'objectId',
    'membershipCsrfTokenFromClient',
    'membershipCsrfTokenFromCookie',
    'previewJwt',
    'companyId',
    'tolerateInstanceAccessDenied',
  ],
  fetcher(
    request: References.CreateOrUpdatePasswordRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.CreateOrUpdatePasswordResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.createOrUpdatePasswordRpc,
      { timeout: ctx.timeout, request }
    );
  },
});
